import { render } from "./TheWheel.vue?vue&type=template&id=752c27ba&scoped=true"
import script from "./TheWheel.vue?vue&type=script&lang=js"
export * from "./TheWheel.vue?vue&type=script&lang=js"

import "./TheWheel.vue?vue&type=style&index=0&id=752c27ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752c27ba"]])

export default __exports__